import moment from 'moment'
import React from 'react'
import Accordion from 'react-bootstrap/Accordion'
import { useNavigate } from 'react-router-dom'
const WorkAndEducation = ({ data }) => {
  const navigate = useNavigate()

  return (
    <div className="mt-2 mt-lg-5">
      <div className="mb-5">
        <Accordion defaultActiveKey={['0', '1', '2', '3', '4']} className="accordian-main accordian-edit" alwaysOpen>
          <Accordion.Item eventKey="0">
            <div className="d-flex justify-content-between">
              <Accordion.Header className="accordin-header">Profile Summary</Accordion.Header>
              <button className="acc-edit-icon d-flex justify-content-center align-items-center bg-transparent border-0" onClick={() => navigate('/profile', { state: { step: 5 } })}>
                <img src="./svg/edit-blue.svg" />
                edit
              </button>
            </div>
            {data?.profile_heading || data?.profile_summary || data?.most_unique_thing ? (
              <Accordion.Body className="px-0">
                <div className="accordian-content mb-4">
                  <p>{data?.profile_heading || 'N/A'} </p>
                </div>
                <div className="accordian-content mb-4">
                  <h3>Summary</h3>
                  <p>{data?.profile_summary || 'N/A'} </p>
                </div>
                <div className="accordian-content mb-4">
                  <h3>Most Unique Thing</h3>
                  <p>{data?.most_unique_thing || 'N/A'} </p>
                </div>
                <div className="content-box d-none d-lg-flex p-3 justify-content-between align-items-center bg-yellow-gr">
                  <div>
                    <h2 className="m-0 text-black fw-normal">Companies prefers applicants with videos</h2>
                    <button className="default-btn mt-3 yellow-border-btn bg-white" onClick={() => navigate('/screening-criteria')}>
                      Update Screening Criteria
                    </button>
                  </div>
                  <img src="./images/layer.png" alt="" />
                </div>
              </Accordion.Body>
            ) : (
              <Accordion.Body className="px-0">
                <div className="text-center mb-5 pb-3">
                  {/* <h3 className='no-data-title'>*No info added yet*</h3> */}
                  <div>
                    <h3 className="no-data-title">No info added yet</h3>
                    <span style={{ fontSize: '12px' }}>Add your info now to boost visibility and improve your chances of landing a job.</span>
                  </div>
                  <img src={`images/empty-data-vector.svg`} alt="no data img" className="mt-3" />
                </div>
              </Accordion.Body>
            )}
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <div className="d-flex justify-content-between">
              <Accordion.Header>Job Preference</Accordion.Header>
              {/* <Accordion.Header className='accordin-header'>Profile Summary</Accordion.Header> */}
              <button className="acc-edit-icon d-flex justify-content-center align-items-center bg-transparent border-0" onClick={() => navigate('/profile', { state: { step: 3 } })}>
                <img src="./svg/edit-blue.svg" />
                edit
              </button>
            </div>
            {data?.role_search_type || data?.preferred_job_location || data?.area_of_interest_1 || data?.area_of_interest_2 || data?.area_of_interest_3 || data?.available_tojoin_from ? (
              <Accordion.Body className="px-0">
                <div className="mb-0 mb-lg-4">
                  <div className="row">
                    <div className="col-6">
                      <div className="accordian-content mb-4">
                        <h3 className="mb-0">Open For</h3>
                        <p className="fs-14 mb-1">{data?.role_search_type || 'N/A'}</p>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="accordian-content mb-4">
                        <h3 className="mb-0">Preferred location(s)</h3>
                        <p className="fs-14 mb-1">{data?.preferred_job_location || 'N/A'}</p>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="accordian-content mb-4">
                        <h3 className="mb-0">Interested in</h3>
                        <p className="fs-14 mb-1">{data?.area_of_interest_1 || 'N/A'}</p>
                        <p className="fs-14 mb-1">{data?.area_of_interest_2 || 'N/A'}</p>
                        <p className="fs-14 mb-1">{data?.area_of_interest_3 || 'N/A'}</p>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="accordian-content mb-4">
                        <h3 className="mb-0">Available to join from</h3>
                        <p className="fs-14 mb-1">{(data?.available_tojoin_from && moment(data?.available_tojoin_from).format('DD MMMM Y')) || 'N/A'}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Accordion.Body>
            ) : (
              <Accordion.Body className="px-0">
                <div className="text-center mb-5 pb-3">
                  <div>
                    <h3 className="no-data-title">No info added yet</h3>
                    <span style={{ fontSize: '12px' }}>Add your info now to boost visibility and improve your chances of landing a job.</span>
                  </div>
                  <img src={`images/empty-data-vector.svg`} alt="no data img" className="mt-3" />
                </div>
              </Accordion.Body>
            )}
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <div className="d-flex justify-content-between">
              <Accordion.Header>Education</Accordion.Header>
              {/* <Accordion.Header className='accordin-header'>Profile Summary</Accordion.Header> */}
              <button className="acc-edit-icon d-flex justify-content-center align-items-center bg-transparent border-0" onClick={() => navigate('/profile', { state: { step: 4 } })}>
                <img src="./svg/edit-blue.svg" />
                edit
              </button>
            </div>
            <Accordion.Body className="px-0">
              <div className="mb-0 mb-lg-4">
                {data?.post_graduation_college ||
                data?.post_graduation_cgpa ||
                data?.post_graduation_degree ||
                data?.post_graduation_specialization ||
                data?.post_graduation_end_date ||
                data?.graduation_college ||
                data?.graduation_cgpa ||
                data?.graduation_degree ||
                data?.graduation_specialization ||
                data?.graduation_end_date ||
                data?.twelfth_board_name ||
                data?.twelfth_percentage ||
                data?.twelfth_stream ||
                data?.tenth_board_name ||
                data?.tenth_percentagev ? (
                  <div className="row">
                    <div className="col-6">
                      <div className="accordian-content mb-4">
                        <h3 className="mb-0">Post Graduation</h3>
                        {data?.post_graduation_college || data?.post_graduation_cgpa || data?.post_graduation_degree || data?.post_graduation_specialization || data?.post_graduation_end_date ? (
                          <>
                            <p className="fs-14 mb-1">
                              College Name : <strong>{data?.post_graduation_college || 'N/A'}</strong>
                            </p>
                            <p className="fs-14 mb-1">
                              CGPA : <strong>{data?.post_graduation_cgpa ? parseFloat(data.post_graduation_cgpa).toFixed(1) : 'N/A'}</strong>
                            </p>
                            <p className="fs-14 mb-1">
                              Degree : <strong>{data?.post_graduation_degree || 'N/A'}</strong>
                            </p>
                            <p className="fs-14 mb-1">
                              Specialization :<strong>{data?.post_graduation_specialization || 'N/A'}</strong>
                            </p>
                            <p className="fs-14 mb-1">
                              End Date : <strong>{(data?.post_graduation_end_date && moment(data?.post_graduation_end_date).format('DD MMMM Y')) || 'N/A'}</strong>
                            </p>
                          </>
                        ) : (
                          <div className="text-center mb-5 pb-3">
                            <div>
                              <h3 className="no-data-title">No info added yet</h3>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="accordian-content mb-4">
                        <h3 className="mb-0">Graduation</h3>
                        {data?.graduation_college || data?.graduation_cgpa || data?.graduation_degree || data?.graduation_specialization || data?.graduation_end_date ? (
                          <>
                            <p className="fs-14 mb-1">
                              College Name : <strong>{data?.graduation_college || 'N/A'}</strong>
                            </p>
                            <p className="fs-14 mb-1">
                              CGPA : <strong>{data?.graduation_cgpa ? parseFloat(data.graduation_cgpa).toFixed(1) : 'N/A'}</strong>
                            </p>
                            <p className="fs-14 mb-1">
                              Degree : <strong>{data?.graduation_degree || 'N/A'}</strong>
                            </p>
                            <p className="fs-14 mb-1">
                              Specialization :<strong>{data?.graduation_specialization || 'N/A'}</strong>
                            </p>
                            <p className="fs-14 mb-1">
                              End Date : <strong>{(data?.graduation_end_date && moment(data?.graduation_end_date).format('DD MMMM Y')) || 'N/A'}</strong>
                            </p>
                          </>
                        ) : (
                          <div className="text-center mb-5 pb-3">
                            <div>
                              <h3 className="no-data-title">No info added yet</h3>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="accordian-content mb-4">
                        <h3 className="mb-0">Class 12 </h3>
                        {data?.twelfth_board_name || data?.twelfth_percentage || data?.twelfth_stream ? (
                          <>
                            <p className="fs-14 mb-1">
                              Board :<strong> {data?.twelfth_board_name || 'N/A'}</strong>
                            </p>
                            <p className="fs-14 mb-1">
                              Percentage : <strong>{data?.twelfth_percentage ? parseFloat(data.twelfth_percentage).toFixed(1) : 'N/A'}</strong>
                            </p>
                            <p className="fs-14 mb-1">
                              Stream : <strong>{data?.twelfth_stream || 'N/A'}</strong>
                            </p>
                          </>
                        ) : (
                          <div className="text-center mb-5 pb-3">
                            <div>
                              <h3 className="no-data-title">No info added yet</h3>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="accordian-content mb-4">
                        <h3 className="mb-0">Class 10 </h3>
                        {data?.tenth_board_name || data?.tenth_percentage ? (
                          <>
                            <p className="fs-14 mb-1">
                              Board :<strong>{data?.tenth_board_name || 'N/A'}</strong>
                            </p>
                            <p className="fs-14 mb-1">
                              Percentage :<strong> {data?.tenth_percentage ? parseFloat(data.tenth_percentage).toFixed(1) : 'N/A'}</strong>
                            </p>
                          </>
                        ) : (
                          <div className="text-center mb-5 pb-3">
                            <div>
                              <h3 className="no-data-title">No info added yet</h3>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="text-center mb-5 pb-3">
                    <div>
                      <h3 className="no-data-title">No info added yet</h3>
                      <span style={{ fontSize: '12px' }}>Add your info now to boost visibility and improve your chances of landing a job.</span>
                    </div>
                    <img src={`images/empty-data-vector.svg`} alt="no data img" className="mt-3" />
                  </div>
                )}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <div className="d-flex justify-content-between">
              <Accordion.Header>Work Experience</Accordion.Header>
              {/* <Accordion.Header className='accordin-header'>Profile Summary</Accordion.Header> */}
              <button className="acc-edit-icon d-flex justify-content-center align-items-center bg-transparent border-0" onClick={() => navigate('/profile', { state: { step: 6 } })}>
                <img src="./svg/edit-blue.svg" />
                edit
              </button>
            </div>
            <Accordion.Body className="px-0">
              {data?.work_experience_duration ||
              data?.last_workex_company ||
              data?.last_workex_designation ||
              data?.last_drawn_ctc ||
              data?.last_workex_domain ||
              data?.last_workex_duration ||
              data?.last_workex_industry ? (
                <>
                  <div className="mb-0 mb-lg-4">
                    <div className="row">
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Total Experience</h3>
                          <p className="fs-14 mb-1">{data?.work_experience_duration || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Most recent company</h3>
                          <p className="fs-14 mb-1">{data?.last_workex_company || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Designation </h3>
                          <p className="fs-14 mb-1">{data?.last_workex_designation || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Duration</h3>
                          <p className="fs-14 mb-1">{data?.last_workex_duration || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Work domain</h3>
                          <p className="fs-14 mb-1">{data?.last_workex_domain || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Industry</h3>
                          <p className="fs-14 mb-1">{data?.last_workex_industry || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Last drawn CTC</h3>
                          <p className="fs-14 mb-1">{data?.last_drawn_ctc || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Internship Company Name</h3>
                          <p className="fs-14 mb-1">{data?.last_intern_company || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Internship Department</h3>
                          <p className="fs-14 mb-1">{data?.last_intern_department || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Internship Duration (in months)</h3>
                          <p className="fs-14 mb-1">{data?.last_intern_duration || 'N/A'}</p>
                        </div>
                      </div>
                    </div>
                  </div>{' '}
                </>
              ) : (
                <div className="text-center mb-5 pb-3">
                  <div>
                    <h3 className="no-data-title">No info added yet</h3>
                    <span style={{ fontSize: '12px' }}>Add your info now to boost visibility and improve your chances of landing a job.</span>
                  </div>
                  <img src={`images/empty-data-vector.svg`} alt="no data img" className="mt-3" />
                </div>
              )}
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <div className="d-flex justify-content-between">
              <Accordion.Header>Additional Information</Accordion.Header>
              {/* <Accordion.Header className='accordin-header'>Profile Summary</Accordion.Header> */}
              <button className="acc-edit-icon d-flex justify-content-center align-items-center bg-transparent border-0" onClick={() => navigate('/profile', { state: { step: 7 } })}>
                <img src="./svg/edit-blue.svg" />
                edit
              </button>
            </div>
            <Accordion.Body className="px-0">
              {data?.languages_known || data?.has_driving_license || data?.has_two_wheeler || data?.has_smartphone || data?.has_laptop ? (
                <>
                  <div className="mb-0 mb-lg-4">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Languages known</h3>
                          <p className="fs-14 mb-1">{data?.languages_known || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Has Driving License</h3>
                          <p className="fs-14 mb-1">{data?.has_driving_license ? 'Yes' : 'No' || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Owns 2 Wheeler </h3>
                          <p className="fs-14 mb-1">{data?.has_two_wheeler ? 'Yes' : 'No' || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Owns Smartphone</h3>
                          <p className="fs-14 mb-1">{data?.has_smartphone ? 'Yes' : 'No' || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="accordian-content mb-4">
                          <h3 className="mb-0">Owns Laptop</h3>
                          <p className="fs-14 mb-1">{data?.has_laptop ? 'Yes' : 'No' || 'N/A'}</p>
                        </div>
                      </div>
                    </div>
                  </div>{' '}
                </>
              ) : (
                <div className="text-center mb-5 pb-3">
                  <div>
                    <h3 className="no-data-title">No info added yet</h3>
                    <span style={{ fontSize: '12px' }}>Add your info now to boost visibility and improve your chances of landing a job.</span>
                  </div>
                  <img src={`images/empty-data-vector.svg`} alt="no data img" className="mt-3" />
                </div>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  )
}

export default WorkAndEducation
